import * as Yup from "yup";

export default async (data) => {
  const schema = Yup.object().shape({
    indicativo: Yup.string().required("Por favor, digite o seu indicativo"),
  });

  await schema.validate(data, { abortEarly: false });
};
